/**
 * Whether input looks like a literal IPv4 or IPv6 address (not a hostname).
 * Matches are conservative; the server still validates.
 */
export function isPlausibleIpAddress(raw) {
  if (raw == null || typeof raw !== 'string') return false;
  const s = raw.trim();
  if (!s) return false;

  if (/^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$/.test(s)) {
    return true;
  }

  if (s.includes(':')) {
    const noZone = s.split('%')[0].replace(/^\[|\]$/g, '');
    if (noZone.length < 3) return false;
    return /^[0-9a-f:.]+$/i.test(noZone) && (noZone.match(/:/g) || []).length >= 2;
  }

  return false;
}
